/**
 * Created by Allan on 20226/01/26.
 * Contact 84880528@qq.com.
 * 登录页面
 */
export default[
	{
		path:'/login',
		hidden:true,
		leaf:true,
		alias:'/',
		meta:{
			title:'loginPhone',
		},
		component: resolve => require(['@/repayment/views/product/login/index.vue'], resolve)
	},
	//订单首页
	{
		path:'/order',
		name:'orderIndex',
		meta:{
			title:'Detalles del pedido',
		},
		component: resolve => require(['@/repayment/views/product/order/index.vue'], resolve)
	},
]



// WEBPACK FOOTER //
// ./src/repayment/router/map/product.js